/**
 * Created by Jonas Wålekvist on 2018-05-31.
 */

import {
    ISymbolStateConfig, ISymbolStates,
    StateReelSymbol,
    SymbolStateTransition
} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {TimelineLite, TweenLite} from "gsap";
import {EdisonGameConfig} from "../../EdisonGameConfig";

export interface IEdisonSymbolStates extends ISymbolStates {
    noWin:ISymbolStateConfig;
    noWinFS:ISymbolStateConfig;
    gold:ISymbolStateConfig;
}

export class EdisonStateReelSymbol extends StateReelSymbol {

    constructor(symName:string, reelId:number, state?:ISymbolStateConfig) {
        super(symName, reelId, state);
    }


    protected addNewStateAnimation(timeline:TimelineLite, newState:SymbolStateTransition, stateAnimation:TimelineSprite, delay:number):void {
        super.addNewStateAnimation(timeline, newState, stateAnimation, delay);

        if(newState.state.keyword === EdisonGameConfig.instance.SYMBOL_STATES.win.keyword) {
            const winTl:TimelineLite = new TimelineLite();
            winTl.add(new TweenLite(this.scale, 0.2, {x : 1.2, y : 1.2}));
            winTl.add(() => new TweenLite(this.scale, 0.2, {x : 1, y : 1, delay : 0.3}));
            timeline.add(winTl, delay);
            return;
        }

        if(newState.state.keyword === EdisonGameConfig.instance.SYMBOL_STATES.noWin.keyword) {
            return;
        }

    }
}